export const AVAILABLE_PLATFORMS = ["Microstrategy", "PowerBIReportServer", "PowerBIService"];

export const PROJECT_DEFAULT = "TEIC PRD";

export const OWNER = "OWNER";

export const ADMIN = "ADMIN";

export const AVAILABLE_CONFIDENTIALITY = [
  "Public",
  "InternalUse",
  "Confidential",
  "HighlyConfidential",
];

export const MANAGEMENT_HR = "MANAGEMENT HR";
